import { connect } from "react-redux";
import * as Redux from "redux";
import * as _ from "lodash";
import ReportReview from "./component";

import {
  reportDurationStringSelector,
  reportEndpointStringSelector,
  reportScheduleStringSelector
} from "../../selectors";

const mapStateToProps = (state: any, ownProps: any): any => {
  return {
    filename: state.reportForm.format.filename,
    format: _.toUpper(state.reportForm.format.extension),
    compressed: state.reportForm.format.compressed ? "True" : "False",
    duration: reportDurationStringSelector(state),
    metrics: state.reportForm.structure.metrics
      .map((d: ReportColumn) => d.name)
      .join(", "),
    dimensions: state.reportForm.structure.dimensions
      .map((d: ReportColumn) => d.name)
      .join(", "),
    endpoint: reportEndpointStringSelector(state),
    schedule: reportScheduleStringSelector(state),
    contacts: state.reportForm.contacts.join(", "),
    enabled: state.reportForm.schedule.enabled ? "True" : "False",
    ownProps: ownProps.next
  };
};

export default connect(mapStateToProps, {})(ReportReview);



// WEBPACK FOOTER //
// ./client/modules/ReportForm/components/ReportReview/container.ts